var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaby({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 126.40613,
    height: 126.406,
    viewBox: "0 0 126.40613 126.406",
    sodipodidocname: "Baby.ai",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,94.805 H 94.805 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "Baby",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,126.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(44.1893,45.562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.168,0.187 -0.247,0.21 -0.25,0.211 -1.872,0.605 -3.351,1.186 -4.751,1.983 -4.755,1.97 -4.759,1.956 -4.762,1.943 -5.894,-2.126 -6.773,-6.331 -7.451,-10.912 -7.708,-12.652 -8,-14.622 -7.61,-16.54 c 0.758,-3.733 2.619,-6.061 5.689,-7.12 3.553,-1.224 7.075,-1.196 10.466,0.085 2.891,1.091 4.66,3.135 5.256,6.075 0.03,0.145 -0.012,0.376 -0.085,0.478 C 9.499,-11.172 4.884,-5.444 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(49.2833,45.5392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 8.764,-10.745 C 8.131,-6.425 7.252,-2.231 6.093,2.009 4.173,0.922 2.167,0.261 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(58.6865,49.6426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 1.647,-5.802 2.724,-11.097 3.293,-16.185 0.525,-4.698 -0.416,-8.448 -2.878,-11.464 -1.778,-2.179 -4.313,-3.62 -7.534,-4.283 -0.95,-0.196 -1.926,-0.273 -2.869,-0.348 -0.423,-0.034 -0.845,-0.067 -1.265,-0.11 l -0.04,-0.003 c -0.116,-0.002 -0.23,-0.003 -0.345,-0.003 -4.017,0 -7.478,1.233 -10.292,3.667 -2.288,1.981 -3.214,4.741 -3.711,6.645 -0.631,2.415 -0.416,4.803 -0.091,7.024 0.807,5.507 1.861,10.488 3.226,15.229 0.041,0.144 0.045,0.159 -0.186,0.394 -4.025,4.094 -5.564,9.837 -4.119,15.361 1.444,5.517 5.592,9.763 11.096,11.358 4.479,1.297 9.29,0.582 13.2,-1.966 C 1.393,22.769 3.991,18.655 4.613,14.029 5.3,8.917 3.795,4.393 0.139,0.583 -0.059,0.378 -0.081,0.285 0,0 m 11.598,39.263 c -22.922,12.638 -51.748,4.301 -64.386,-18.621 -12.637,-22.922 -4.3,-51.748 18.621,-64.386 22.922,-12.637 51.749,-4.3 64.386,18.621 12.638,22.922 4.301,51.749 -18.621,64.386",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(55.0269,71.0778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.787,0.671 -3.186,2.724 -8.403,2.507 -3.162,-0.124 -6.262,-1.747 -8.505,-4.452 -2.328,-2.807 -3.383,-6.312 -2.893,-9.616 0.472,-3.189 2.197,-6.022 4.856,-7.975 2.645,-1.943 5.847,-2.737 9.011,-2.237 5.231,0.826 8.724,3.903 10.102,8.9 C 5.549,-7.862 4.146,-3.53 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby);
export default __webpack_public_path__ + "static/media/baby.359af474985435a3b2eb016b1be665ca.svg";
export { ForwardRef as ReactComponent };